import { effect, inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { aplicacion, AsignaturaItem, asignaturas, DataCore, defaultFilterData, filterData, grado, GruposLinks, RecientesApp, responseDataCurso } from '../interface/data-core';
import { BehaviorSubject } from 'rxjs';
import { agruparAsignaturas, ASIGNATURA_COMPONENT_ID, FILTER_LABEL_ASIGNATURA, FILTER_LABEL_CLASS_ASIGNATURA, FILTER_LABEL_GRADO, GRADOS_COMPONENT_ID, onRemoveClass } from '../utils/generales';
import { CargarDataService } from './cargar-data.service';
import { ErrorDetailInterface, ResponseGenericInterface } from '../interface/response-generic.interface';
import { MensajesService } from './mensajes.service';
import { AuthService } from '../auth/services/auth.service';






@Injectable({
    providedIn: 'root'
})
export class CargarConfService {
    public _auth = inject(AuthService);


    public carrucel_texto: string = environment.carrucel_texto;
    private id = 'paleta-colores';
    private faviconId = 'dynamic-favicon';
    private path = environment.paleta_colores;
    private faviconPath = 'assets/redi/img/Qrologo.ico'; //environment.url_img_favicon;
    private cache: any | null = null;

    public dataGlobal: DataCore | null = null;
    public dataGlobalFiltrada: DataCore | null = null;
    // Variable global para recientes
    public recientes: RecientesApp[] = [];
    public conoce: RecientesApp[] = [];
    private filtersSubject = new BehaviorSubject<filterData>({ ...defaultFilterData });
    filters$ = this.filtersSubject.asObservable();

    private linksCache: GruposLinks[] | null = null;
    public dataGlobalLinks: GruposLinks[] = [];
    public labelLinks: string = 'Links dinámicos'; // Etiqueta para los enlaces

    public filters: filterData = { ...defaultFilterData };
    private cargarData = inject(CargarDataService);
    private mensajeService = inject(MensajesService);
    private localData: boolean = environment.offline; // Cambiar a true para usar datos locales
    public readonly localUrl: boolean = environment.offline; // Cambiar a true para usar URL local

    public readonly msgLocalUrl: string = 'Este enlace sólo se puede consultar desde el portal online';
    /** Tipo de enlace dinámico
     * 0 = ninguno
     * 1 = catalogos
     * 2 = guia docente
     * 3 = libros externos
    */
    public tiposLinkDinamico: number = 0;
    public loggedIn: boolean = this._auth.isAuthenticated();
    constructor() {
        this.cargar();
        this.cargarFavicon();
        effect(() => {
            this.loggedIn = this._auth.isAuthenticated();
            console.debug('Cambio el estado de auth:', this.loggedIn);
            this.dataGlobal = null;
            this.dataGlobalFiltrada = null;
            this.recientes = [];
            this.conoce = [];

            this.ongetHome();

            if (this.localData || !this.loggedIn) {
                this.getDataLocal();
            } else {
                this.getDataOnline();
            }
            // aquí lanzas lógica cuando cambie
        });





        // Suscripción interna: reacciona a cada cambio
        this.filters$.subscribe((newFilters) => {
            //console.log('🌀 Filtros actualizados dentro del servicio:', newFilters);
            const current = this.filtersSubject.getValue();

            this.filters = { ...current }
            this.onFiltersChanged(newFilters);
        });
    }


    getDataLocal() {
        this.cargarData.getDataById(environment.config_id_portal).subscribe({
            next: (response: ResponseGenericInterface<responseDataCurso>) => {
                // Manejar la respuesta aquí
                console.debug('Datos cargados desde servicio:', response);
                this.dataGlobal = response.data.curso;
                this.dataGlobalFiltrada = response.data.curso;
                if (response.data.recientes) {
                    this.recientes = response.data.recientes;
                }
                if (response.data.conoce) {
                    this.conoce = response.data.conoce;
                }
                this.validarUnico();

            },
            error: (errorDetail: ErrorDetailInterface[]) => {
                console.error('Error al cargar datos desde servicio:', errorDetail);
                errorDetail.forEach(itemError => {
                    this.mensajeService.showError(itemError.errorMessage);
                });
            }
        });
    }
    getDataOnline() {
        // 2. solicitar la carga inicial de datos mediante servicio externo
        this.cargarData.getDataPortal(environment.config_id_portal).subscribe({
            next: (response: ResponseGenericInterface<responseDataCurso>) => {
                // Manejar la respuesta aquí
                console.debug('Datos cargados desde servicio:', response);
                this.dataGlobal = response.data.curso;
                this.dataGlobalFiltrada = response.data.curso;
                if (response.data.recientes) {
                    this.recientes = response.data.recientes;
                }
                if (response.data.conoce) {
                    this.conoce = response.data.conoce;
                }
                this.validarUnico();
            },
            error: (errorDetail: ErrorDetailInterface[]) => {
                console.error('Error al cargar datos desde servicio:', errorDetail);
                errorDetail.forEach(itemError => {
                    this.mensajeService.showError(itemError.errorMessage);
                });
            }
        });
    }

    filtrarGradosPermitidos() {
        if (!this.loggedIn) {
            return;
        }
        const tablaValores: Record<string, number> = JSON.parse(
            JSON.stringify(environment.equivalencias)
        );
        const codes = environment.offline ? environment.gradosPermitidos : this._auth.currentUserPermisos()?.codes ?? [];
        if (codes && this.dataGlobal) {
            const valores = codes.map(c => tablaValores[c]);
            this.dataGlobal.grados = this.dataGlobal.grados.filter((grado) => valores.includes(grado.i));
            this.dataGlobal.asignaturas = this.dataGlobal.asignaturas.filter((asignatura) => valores.includes(asignatura.g));
            this.dataGlobal.aplicaciones = this.dataGlobal.aplicaciones.filter((aplicacion) => valores.includes(aplicacion.g ?? -1));
            this.dataGlobalFiltrada = JSON.parse(JSON.stringify(this.dataGlobal));
        }
    }


    validarUnico() {
        this.filtrarGradosPermitidos();
        if (this.dataGlobalFiltrada) {
            if (this.dataGlobalFiltrada.asignaturas.length === 1 && this.dataGlobalFiltrada.grados.length === 1) {
                let [asignatura] = [...this.dataGlobalFiltrada.asignaturas];
                let [grado] = [...this.dataGlobalFiltrada.grados];
                this.updateFilterField(FILTER_LABEL_CLASS_ASIGNATURA as keyof filterData, asignatura.i ?? null);
                this.updateFilterField(FILTER_LABEL_GRADO as keyof filterData, grado.i ?? null);
            }
        }



    }
    ongetHome() {

        this.updateFilters({ ...defaultFilterData });
        onRemoveClass(ASIGNATURA_COMPONENT_ID, 'onHide');
        onRemoveClass(ASIGNATURA_COMPONENT_ID, 'd_firstsection');
        onRemoveClass(GRADOS_COMPONENT_ID, 'onHide');
        onRemoveClass(GRADOS_COMPONENT_ID, 'd_firstsection');


        // Aquí podrías inicializar algo si es necesario
    }

    /**
     * Carga el archivo CSS definido en environment.paleta_colores
     */
    cargar(): void {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = this.path;
        link.id = this.id;
        const existente = document.getElementById(this.id);
        if (existente) {
            existente.replaceWith(link);
        } else {
            document.head.appendChild(link);
        }
    }

    /**
     * Carga el favicon definido en environment.url_img_favicon
     */
    cargarFavicon(): void {
        try {
            // Crear el elemento link para el favicon
            const faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            faviconLink.type = 'image/png';
            faviconLink.href = `assets/redi/img/favicons/${environment.url_favicons}.png`;
            faviconLink.id = this.faviconId;

            // Buscar si ya existe un favicon dinámico
            const existenteFavicon = document.getElementById(this.faviconId);

            if (existenteFavicon) {
                // Reemplazar el favicon existente
                existenteFavicon.replaceWith(faviconLink);
                console.debug('Favicon reemplazado:', this.faviconPath);
            } else {
                // Buscar favicon existente en el HTML
                const faviconExistente = document.querySelector('link[rel="icon"], link[rel="shortcut icon"]');

                if (faviconExistente) {
                    // Reemplazar el favicon existente del HTML
                    faviconExistente.replaceWith(faviconLink);
                    console.debug('Favicon HTML reemplazado por dinámico:', this.faviconPath);
                } else {
                    // Agregar nuevo favicon al head
                    document.head.appendChild(faviconLink);
                    console.debug('Favicon dinámico agregado:', this.faviconPath);
                }
            }

            // Actualizar dinámicamente el <title>
            const titleText = environment.title_html;
            let titleTag = document.querySelector('title');
            if (!titleTag) {
                titleTag = document.createElement('title');
                document.head.appendChild(titleTag);
            }
            titleTag.textContent = titleText;
            console.debug('Título actualizado dinámicamente:', titleText);
        } catch (error) {
            console.error('Error al cargar favicon:', error);
        }
    }

    /**
     * Obtiene la ruta del archivo CSS actualmente cargado
     */
    getRutaActual(): string | null {
        const link = document.getElementById(this.id) as HTMLLinkElement;
        return link?.href ?? null;
    }

    /**
     * Obtiene la ruta del favicon actualmente cargado
     */
    getFaviconActual(): string | null {
        const faviconLink = document.getElementById(this.faviconId) as HTMLLinkElement;
        return faviconLink?.href ?? null;
    }

    /**
     * Fuerza la recarga del favicon (útil si cambia la configuración)
     */
    recargarFavicon(): void {
        this.faviconPath = environment.url_img_favicon;
        this.cargarFavicon();
    }



    /**
     * Limpia el cache para forzar una nueva carga
     */
    clearCache(): void {
        this.cache = null;
    }

    async setCatalogosGlobalLinks(): Promise<void> {
        try {
            // Limpiar enlaces actuales
            this.dataGlobalLinks = [];
            this.cargarData.getDataCatalogo().subscribe({
                next: (response: ResponseGenericInterface<GruposLinks[]>) => {
                    // Manejar la respuesta aquí
                    console.debug('Datos cargados desde servicio:', response);
                    this.dataGlobalLinks = response.data ?? [];

                },
                error: (errorDetail: ErrorDetailInterface[]) => {
                    this.mensajeService.showError("Error al cargar los enlaces del catálogo.");

                    console.error('Error al cargar datos desde servicio:', errorDetail);
                    errorDetail.forEach(itemError => {
                        this.mensajeService.showError(itemError.errorMessage);
                    });
                }
            });

        } catch (error) {
            console.error('❌ Error al cargar enlaces:', error);
            this.dataGlobalLinks = [];
        }
    }


    async setlibrosGlobalLinks(archivo: string): Promise<void> {
        try {

            // Limpiar enlaces actuales
            this.dataGlobalLinks = [];
            this.cargarData.getDataLibros(archivo).subscribe({
                next: (response: ResponseGenericInterface<GruposLinks[]>) => {
                    // Manejar la respuesta aquí
                    console.debug('Datos cargados desde servicio:', response);
                    this.dataGlobalLinks = response.data ?? [];

                },
                error: (errorDetail: ErrorDetailInterface[]) => {
                    this.mensajeService.showError("Error al cargar los enlaces del catálogo.");

                    console.error('Error al cargar datos desde servicio:', errorDetail);
                    errorDetail.forEach(itemError => {
                        this.mensajeService.showError(itemError.errorMessage);
                    });
                }
            });

        } catch (error) {
            console.error('❌ Error al cargar enlaces:', error);
            this.dataGlobalLinks = [];
        }
    }



    /**
     * Limpia el cache de enlaces
     */
    clearLinksCache(): void {
        this.linksCache = null;
    }

    /**
     * Fuerza la recarga de enlaces (ignora cache)
     */
    async forceReloadLinks(): Promise<void> {
        this.clearLinksCache();
        await this.setCatalogosGlobalLinks();
    }

    // Actualiza el objeto completo
    updateFilters(newFilters: filterData): void {
        this.filtersSubject.next({ ...newFilters });
    }

    // Actualiza una propiedad individual del objeto
    updateFilterField<K extends keyof filterData>(field: K, value: filterData[K]): void {
        const current = this.filtersSubject.getValue();
        this.filtersSubject.next({ ...current, [field]: value });
    }

    getCurrentFilters(): filterData {
        return this.filtersSubject.getValue();
    }

    /**
     * Método que reacciona internamente a los cambios de filtros
     * Aplica filtros secuenciales: grado -> asignatura -> aplicaciones
     */
    private onFiltersChanged(filters: filterData): void {
        console.debug('Filtra la información con el servicio:', filters);

        // Salida temprana si no hay datos globales
        if (!this.dataGlobal) {
            console.warn('No hay datos globales disponibles para filtrar');
            return;
        }

        // Inicializar datos filtrados con copia de los originales
        this.dataGlobalFiltrada = {
            aplicaciones: [...this.dataGlobal.aplicaciones],
            grados: [...this.dataGlobal.grados],
            asignaturas: [...this.dataGlobal.asignaturas],
            temas: { ...this.dataGlobal.temas },
        };

        // Aplicar filtro por grado
        this.applyGradoFilter(filters);

        // Aplicar filtro por asignatura (depende del filtro de grado)
        this.applyAsignaturaFilter(filters);

        if (filters.class_asignatura && filters.grado) {
            let asignatura = this.dataGlobalFiltrada.asignaturas.find(
                asignatura => asignatura.class === filters.class_asignatura && asignatura.g === filters.grado
            );

            if (asignatura?.i) {
                filters.asignatura = asignatura.i; // Actualizar el filtro de asignatura con el ID encontrado
            }
        }

        this.dataGlobalFiltrada.aplicaciones = this.filtrarAplicaciones(
            this.dataGlobalFiltrada.aplicaciones,
            filters
        );

        console.debug('Data filtrada:', this.dataGlobalFiltrada);
    }

    /**
     * Aplica el filtro por grado a las asignaturas
     */
    private applyGradoFilter(filters: filterData): void {
        if (!filters.grado || !this.dataGlobalFiltrada) return;

        // Filtrar asignaturas por grado
        this.dataGlobalFiltrada.asignaturas = this.dataGlobal!.asignaturas.filter(
            asignatura => asignatura.g === filters.grado
        );
    }

    /**
     * Aplica el filtro por asignatura a los grados disponibles
     */
    private applyAsignaturaFilter(filters: filterData): void {
        if (!filters.asignatura || !this.dataGlobalFiltrada) return;

        // Obtener asignaturas base (filtradas por grado si aplica)
        const asignaturasBase = filters.grado
            ? this.dataGlobal!.asignaturas.filter(
                asignatura => asignatura.g === filters.grado && asignatura.class === filters.class_asignatura
            )
            : this.dataGlobal!.asignaturas;

        // Agrupar asignaturas y encontrar la seleccionada
        const asignaturasList = agruparAsignaturas(asignaturasBase);
        const selectedAsignatura = asignaturasList.find(
            asignatura => asignatura.clase === filters.class_asignatura
        );

        // Filtrar grados que contienen la asignatura seleccionada
        if (selectedAsignatura) {

            this.dataGlobalFiltrada.grados = this.dataGlobal!.grados.filter(
                grado => selectedAsignatura.listGrados.includes(grado.i)
            );


        }
    }


    private filtrarAplicaciones(aplicaciones: aplicacion[], filtros: filterData): aplicacion[] {
        return aplicaciones.filter(app => {
            // Filtrar por grado
            if (filtros.grado !== null && app.g !== filtros.grado) {
                return false;
            }

            // Filtrar por asignatura
            if (filtros.asignatura !== null && app.a !== filtros.asignatura) {
                return false;
            }


            // Filtrar por tema (buscando coincidencia exacta en 'pc')
            if (filtros.tema !== null && !(app.pc ?? '').includes(filtros.tema)) {
                return false;
            }

            // Filtrar por texto (coincidencia parcial en 'n', 'o', 'pc')
            if (filtros.texto !== null) {
                const texto = filtros.texto.toLowerCase();
                const match = (app.n ?? '').toLowerCase().includes(texto) ||
                    (app.o ?? '').toLowerCase().includes(texto) ||
                    (app.pc ?? '').toLowerCase().includes(texto);
                if (!match) {
                    return false;
                }
            }

            // Filtrar por categoría general
            if (filtros.categoria.length > 0 && !filtros.categoria.includes(app.cg ?? '')) {
                return false;
            }

            return true;
        });
    }

    public filtrarAplicacionesByGRadoAsignaturaTema(aplicaciones: aplicacion[], filtros: filterData): aplicacion[] {
        return aplicaciones.filter(app => {
            // Filtrar por grado
            if (filtros.grado !== null && app.g !== filtros.grado) {
                return false;
            }

            // Filtrar por asignatura
            if (filtros.asignatura !== null && app.a !== filtros.asignatura) {
                return false;
            }


            // Filtrar por tema (buscando coincidencia exacta en 'pc')
            if (filtros.tema !== null && !(app.pc ?? '').includes(filtros.tema)) {
                return false;
            }

            return true;
        });
    }

    public filtrarCategoriasAplicacionesByGRadoAsignaturaTema(aplicaciones: aplicacion[], filtros: filterData): string[] {
        const filtradas = aplicaciones.filter(app => {
            // Filtrar por grado
            if (filtros.grado !== null && app.g !== filtros.grado) {
                return false;
            }

            // Filtrar por asignatura
            if (filtros.asignatura !== null && app.a !== filtros.asignatura) {
                return false;
            }

            // Filtrar por tema (buscando coincidencia exacta en 'pc')
            if (filtros.tema !== null && !(app.pc ?? '').includes(filtros.tema)) {
                return false;
            }

            return true;
        });

        // Obtener los valores únicos de 'cg' y devolverlos como array de string
        const categorias = Array.from(new Set(filtradas.map(app => app.cg))).filter((cat): cat is string => typeof cat === 'string');
        return categorias;
    }
    /**
 *
 * @param url cadena a abrir en una nueva ventana
 */
    onOpenUrlTarget(url: string) {

        const currentUrl = window.location.origin;
        const newUrl = `${currentUrl}${url}`;

        var miRedirect = document.createElement('a');
        miRedirect.setAttribute('href', `${newUrl}`);
        miRedirect.setAttribute('target', '_blank');
        miRedirect.click();
    }

}
